import { render, staticRenderFns } from "./work-with-us.vue?vue&type=template&id=1140dc21&scoped=true"
import script from "./work-with-us.vue?vue&type=script&lang=js"
export * from "./work-with-us.vue?vue&type=script&lang=js"
import style0 from "./work-with-us.vue?vue&type=style&index=0&id=1140dc21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140dc21",
  null
  
)

export default component.exports